import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

export default function SelectBranchPage() {
  const { user, currentBranch, selectBranch, logout } = useAuth();
  const navigate = useNavigate();

  const branches = user?.assigned_branches || [];

  // Auto-select branch if manager has only 1 active assigned branch
  useEffect(() => {
    if (user && user.role === 'center_manager') {
      if (branches.length === 1 && !currentBranch) {
        selectBranch(branches[0]);
        navigate('/');
      }
    }
  }, [user, branches, currentBranch, selectBranch, navigate]);

  if (!user || user.role !== 'center_manager') {
    navigate('/login');
    return null;
  }

  const handleSelect = (branch) => {
    selectBranch(branch);
    navigate('/');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #ede9fe 0%, #f5f3ff 100%)',
      fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
      padding: '24px'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(255, 255, 255, 0.5)',
        borderRadius: '24px',
        padding: '40px',
        maxWidth: '500px',
        width: '100%',
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05)',
        textAlign: 'center'
      }}>
        <h2 style={{ fontSize: '24px', fontWeight: 700, color: '#1f2937', marginBottom: '8px', marginTop: 0 }}>
          Welcome back, {user.name}
        </h2>
        <p style={{ fontSize: '15px', color: '#6b7280', marginBottom: '32px' }}>
          Select a branch to manage and continue to the dashboard
        </p>

        {branches.length === 0 ? (
          <div style={{
            padding: '20px 16px',
            background: '#fee2e2',
            border: '1px solid #fca5a5',
            borderRadius: '16px',
            color: '#991b1b',
            fontWeight: 600,
            fontSize: '14px',
            marginBottom: '28px',
            lineHeight: 1.5
          }}>
            🚫 Your manager account or branch access is currently disabled/inactive. Please contact Administrator.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '32px' }}>
            {branches.map((branch) => (
              <button
                key={branch.branch_id}
                onClick={() => handleSelect(branch)}
                style={{
                  background: '#ffffff',
                  border: '2px solid #e5e7eb',
                  borderRadius: '16px',
                  padding: '20px',
                  textAlign: 'left',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  outline: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#7c3aed';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(124, 58, 237, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e5e7eb';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.02)';
                }}
              >
                <div>
                  <div style={{ fontWeight: 600, fontSize: '16px', color: '#111827' }}>
                    {branch.name}
                  </div>
                  <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '4px' }}>
                    Manager Access Assigned
                  </div>
                </div>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  background: '#ede9fe',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#7c3aed',
                  fontSize: '18px',
                  fontWeight: 'bold'
                }}>
                  →
                </div>
              </button>
            ))}
          </div>
        )}

        <button
          onClick={handleLogout}
          style={{
            background: 'none',
            border: 'none',
            color: '#ef4444',
            fontWeight: 500,
            fontSize: '14px',
            cursor: 'pointer',
            textDecoration: 'underline',
            outline: 'none'
          }}
        >
          Logout from account
        </button>
      </div>
    </div>
  );
}
